import { clsx } from 'clsx'
import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('views.calling_sessions.view_all_supporters')

export type OutcomeType = 'successful' | 'unsuccessful'

type OutcomeBadgeProps = {
  outcome: OutcomeType
}

const badgeClasses = clsx(
  'tw:flex tw:w-fit',
  'tw:rounded-md tw:font-medium tw:text-xs tw:px-2 tw:py-0.5',
  'tw:justify-center tw:items-center',
  'tw:bg-gray-neutral-100 tw:text-black tw:border tw:border-gray-neutral-200'
)

export function OutcomeBadge({ outcome }: OutcomeBadgeProps) {
  const text = t(`outcomes.${outcome}`)

  return (
    <span className={badgeClasses} data-testid={`${outcome}-outcome-badge`}>
      {text}
    </span>
  )
}

